module.exports = __webpack_public_path__ + "img/master_card_icon.6eb4b38d.png";